<template>
  <div v-loading="$store.state.loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="min-height: 100vh;">
    <router-view></router-view>
    <el-dialog title="修改密码" :visible.sync="$store.state.pasOff" :close-on-click-modal="!1" :close-on-press-escape="!1" :show-close="!1" width="410px">
      <el-form label-width="auto">
        <el-form-item label="旧密码：">
          <el-input v-model="password" show-password clearable placeholder="旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input v-model="newPassword" show-password clearable placeholder="新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码：">
          <el-input v-model="newPassword1" show-password clearable placeholder="确认新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="managerAdminPasswordEditFn">确认修改</el-button>
        <el-button type="info" @click="$store.state.pasOff = !1;password = '';newPassword = '';newPassword1 = '';">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data(){
    return {
      password: '',
      newPassword: '',
      newPassword1: '',
    }
  },
  methods: {
    async managerAdminPasswordEditFn(){
      if(this.password == ''){
        this.$alert("请输入旧密码", {
          confirmButtonText: '确定',
          showClose: false,
        });
      }else if(this.newPassword == ''){
        this.$alert("请输入新密码", {
          confirmButtonText: '确定',
          showClose: false,
        });
      }else if(this.newPassword !== this.newPassword1){
        this.$alert("两次密码不一至", {
          confirmButtonText: '确定',
          showClose: false,
        });
      }else{
        this.$store.state.loading = true;
        let newData = await this.$api.managerAdminPasswordEdit({
          newPassword: this.newPassword,
          oldPassword: this.password,
        })
        if(newData.body.code === 200){
          this.$store.state.token = '';
          localStorage.removeItem('SHANGYI_TOKEN');
          localStorage.removeItem('SHANGYI_PROFILE');
          this.$store.state.pasOff = !1;
          this.password = '';
          this.newPassword = '';
          this.newPassword1 = '';
          this.$store.state.token = '';
          this.$store.state.profile = {opts: []};
          this.$alert('密码修改成功，请重新登录系统', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push('/login')
            }
          });
        }         
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue